import { createSelector } from '@ngrx/store';
import { getJobsiteSalesArea, getJobsiteSelected } from '@ordersnproducts/modules/order-builder/reducers';
import { IJobsiteSalesArea } from '@cemex-core/cmx-api';

/**
 * Selector to get the payment term for a jobsite.
 *
 * This selector takes the selected jobsite and its associated sales areas,
 * finds the sales area that matches the jobsite's shipment location ID,
 * and returns the payment term for that sales area.
 *
 * @constant
 * @param {Function} getJobsiteSelected - Selector to get the selected jobsite.
 * @param {Function} getJobsiteSalesArea - Selector to get the sales areas associated with the jobsite.
 * @returns {string} The payment term for the selected jobsite.
 */
export const getPaymentTermByJobsite = createSelector(
  getJobsiteSelected,
  getJobsiteSalesArea,
  (jobsite, salesAreas) => {
    const salesAreaSelected = salesAreas.find((saleArea) => saleArea.jobsite.jobsiteId === jobsite.shipmentLocationId);
    return (salesAreaSelected as IJobsiteSalesArea).paymentTerm;
  },
);
